import { Event } from "../events/Event";
import { InputManager } from "../events/InputManager";
import { RenderTargetFormat } from "../RenderEngine/RenderEnum/RenderTargetFormat";
import { RenderTexture2D } from "../resource/RenderTexture2D";
import { Texture } from "../resource/Texture";
import { AlignType, LoaderFitMode, VAlignType } from "./Const";
import { GLoader } from "./GLoader";
import { GRoot } from "./GRoot";
export class DragDropManager {
    static get inst() {
        return DragDropManager._inst || (DragDropManager._inst = new DragDropManager());
    }
    constructor() {
        this.iconWidth = 200;
        this.iconHeight = 200;
        let agent = this.agent = new GLoader();
        agent.name = "dragAgent";
        agent.anchor(0.5, 0.5);
        agent.mouseEnabled = false;
        agent.draggable = true;
        agent.fitMode = LoaderFitMode.Contain;
        agent.shrinkOnly = true;
        agent.align = AlignType.Center;
        agent.valign = VAlignType.Middle;
        agent.zOrder = Number.POSITIVE_INFINITY;
        agent.on(Event.DRAG_END, this, this._dragEnd);
    }
    get dragging() {
        return this.agent.parent != null;
    }
    start(source, icon, data, iconWidth, iconHeight) {
        if (this.agent.parent != null)
            return;
        this._source = source;
        let pt = InputManager.getTouchPos();
        this.agent.pos(pt.x, pt.y);
        if (typeof (icon) === 'string')
            this.agent.src = icon;
        else if (icon != null) {
            if (this._rt == null) {
                let rt = new RenderTexture2D(this.iconWidth, this.iconHeight, RenderTargetFormat.R8G8B8A8);
                this._rt = new Texture(rt);
            }
            icon.drawToRenderTexture2D(this._rt.width, this._rt.height, 0, 0, this._rt.bitmap);
            this.agent.texture = this._rt;
        }
        this.agent.size(iconWidth || this.iconWidth, iconHeight || this.iconHeight);
        GRoot.inst.addChild(this.agent);
        this.agent.startDrag(null, false, null, null, data);
    }
    stop() {
        if (this.agent.parent != null) {
            this.agent.src = null;
            this.agent.stopDrag();
            this.agent.removeSelf();
            this._source = null;
        }
    }
    _dragEnd(data, cancelled) {
        if (this.agent.parent == null)
            return;
        this.agent.src = null;
        this.agent.removeSelf();
        let source = this._source;
        this._source = null;
        if (!cancelled) {
            let obj = InputManager.touchTarget;
            while (obj != null) {
                if (obj.hasListener(Event.DROP)) {
                    obj.event(Event.DROP, [source, data]);
                    return;
                }
                obj = obj.parent;
            }
        }
    }
}
